import type { ReportTable, ReportTimeFilter } from '@erp/shared-types';

import type { DownloadCSVOptions } from '@/utils/csvDownload';
import { getVisibleColumnIndices } from '@/utils/reportTableUtils';

export function reportTableToDownloadOptions({
  table,
  filename,
  timeFilter,
  year,
  rowLabelHeader,
}: {
  table: ReportTable;
  filename: string;
  timeFilter: ReportTimeFilter;
  year?: number;
  rowLabelHeader: string;
}): DownloadCSVOptions {
  const visibleColumnIndices = getVisibleColumnIndices(table, timeFilter, year);
  const columns = [
    { id: '_label', label: rowLabelHeader },
    ...visibleColumnIndices.map((index) => ({
      id: table.columnHeaders[index] ?? '',
      label: table.columnHeaders[index] ?? '',
    })),
  ];
  const data = table.rows.map((row) => {
    const record: Record<string, unknown> = {
      _label: row.label,
    };
    visibleColumnIndices.forEach((index) => {
      const header = table.columnHeaders[index] ?? '';
      const cell = row.cells[index];
      record[header] = cell
        ? { value: cell.value, formattedValue: cell.formattedValue }
        : { value: 0, formattedValue: '-' };
    });
    return record;
  });
  return { data, filename, columns };
}
